<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <div class="form-help">
            <span>{{ getTranslations.visitor_forgot_password_2_2_steps_left }}</span>
          </div>
          <div class="progressbar-container">
            <ol class="progress">
              <li class="is-complete" data-step="1">
              </li>
              <li class="is-active" data-step="2">
              </li>
              <li data-step="3" class="progress__last">
              </li>
            </ol>
          </div>
          <div class="signup-form">
            <div class="form-help">
              <p>{{ getTranslations.visitor_forgot_password_2_send_unique_code_msg }}</p>
              <img class="form-help__icon" src="static/images/keypad-icon.svg" alt="">
            </div>
            <form action="">
              <div class="form-group" :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="text" class="form-group__textfield"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_forgot_password_2_enter_4digit_validation_code"
                       @keyup="check" v-model="pin"/>
                <span v-show="getMessage(message) && pin" class="form-group__feedback">{{ getMessage(message) }}</span>
              </div>
              <input type="submit" :value="getTranslations.visitor_forgot_password_2_button_continue"
                     :class="['btn btn--medium btn--main',( hasErrors ? 'deactivated' : '')]" @click.prevent="checkButton">
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';

export default {
  mixins: [IntegrationMixin],
  data() {
    return {
      pin: '',
      message: '',
      hasErrors: false,
    };
  },
  methods: {
    ...mapMutations('profile', [
      'setHashedPassForForgotPass',
    ]),
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    clearData() {
      this.pin = '';
      this.message = '';
      this.hasErrors = false;
    },
    check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.pin.match(validPinRegex);
      if (!validPin) {
        this.message = 'visitor_forgot_password_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkButton() {
      if (this.pin.length >= 4 && this.pin.length <= 8 && !this.hasErrors) {
        this.message = '';
        if (this.hasResub()) {
          this.alternateForgotVerifyPinProcess();
        } else {
          this.standardForgotVerifyPinProcess();
        }
        this.$axios.get(`api/verifyPinForForgotPassword?msisdn=${this.forgotPasswordInfo}&pin=${this.pin}`).then((response) => {
          const resp = response.data.responseEnum;
          if (resp === 'OPERATION_SUCCESS') {
            this.setHashedPassForForgotPass(response.data.data.hashedPass);
            this.$router.push('forgotPassword3');
            this.message = '';
          } else {
            if (resp === 'PIN_EXPIRED') {
              this.message = 'visitor_sign_up_2_pin_expired';
            } else if (resp === 'WRONG_PIN') {
              this.message = 'visitor_forgot_password_2_warning_msg_wrong_verification_code';
            } else if (resp === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (resp === 'SERVER_ERROR') {
              this.message = 'SERVER_ERROR';
            } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            }
            this.hasErrors = true;
          }
        });
      } else {
        this.message = 'visitor_forgot_password_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapState('profile', [
      'forgotPasswordInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPassword2.vue